import { combineReducers } from 'redux';

import { carouselReducer } from './carousel';
import { commonReducer } from './common';
import { conversationDataRReducer } from './conversationDataR';
import { conversationNewReducer } from './conversationNew';
import { conversationPreviewReducer } from './conversationPreview';
import { dashboardReducer } from './dashboard';
import { deploymentReducer } from './deployment';
import { deploymentsReducer } from './deployments';
import { entitiesReducer } from './entities';
import { fbPagesDataReducer } from './fbPagesData';
import { formReducer } from './form';
import { formCardReducer } from './formCard';
import { trainingReducer } from './training';
import { userReducer } from './user';

export const allReducers = combineReducers({
  carousel: carouselReducer,
  common: commonReducer,
  conversationsDataR: conversationDataRReducer,
  conversationData: conversationNewReducer,
  conversationPreview: conversationPreviewReducer,
  dashboard: dashboardReducer,
  deploymentData: deploymentReducer,
  deployments: deploymentsReducer,
  entities: entitiesReducer,
  fbPagesData: fbPagesDataReducer,
  form: formReducer,
  formCardsData: formCardReducer,
  training: trainingReducer,
  user: userReducer,
});
